/* Potencium — product-description "Zamów / order" CTAs.
   Each product's description carries its own per-product order button using the vx…-cta naming
   convention (.vxg-cta, .vxsum-cta, .vxgel-cta, .vxvid-cta, .fnx-cta, …).
   HISTORY (corrected 2026-08-09): these hrefs USED to be hardcoded /cart/<variant>:1 permalinks
   that dumped the shopper into native Shopify checkout — bypassing the Releasit COD form and
   wiping the bundle — whenever this script failed to load (FB/IG webviews, 11-14% JS error rate).
   All 15 such anchors across 8 products have now been rewritten at the SOURCE (product
   descriptionHtml, via Admin API) to href="#pt-buybox". So the raw href is now SAFE on its own:
   with zero JS it is a plain in-page anchor jump to the buy box. This script is no longer the
   only thing standing between a shopper and native checkout — it now only upgrades that jump to
   a smooth scroll + attention pulse. Some older anchors are dead #/#order links and newer
   products use .fnx-scroll-to-shopify with no href at all; both are still handled here.
   NEW behavior (2026-06-22, updated 2026-06-25): ONE delegated handler intercepts every vx…-cta /
   fnx-cta / fnx-scroll-to-shopify / cart-permalink anchor inside .pt-pdp__desc and SMOOTH-SCROLLS
   the shopper up to the working buy box
   (#pt-buybox: title → price → "Ilość" qty → Vitals bundle widget → "Dodaj do koszyka" ATC →
   Releasit "Kup teraz"), with a brief attention pulse. It does NOT navigate to /cart, does NOT
   reload, does NOT open the Releasit COD popup, and never reaches native checkout. Generic across
   all current + future products (matches by href pattern /cart/<digits>:<n> and the vx…-cta class,
   no hardcoded variant ids).

   Memory hygiene: ONE document-level capture-phase listener pair (click + mousedown), installed
   exactly once and guarded against double-binding. Listeners are attached with an AbortController
   signal and torn down on shopify:section:unload; re-armed on shopify:section:load. */
(function vxDescriptionOrderCtas(){
  if (typeof document === 'undefined') return;

  var installed = false;     // guard against double-binding the document listeners
  var ac = null;             // AbortController for the current listener generation
  var pulseTimer = null;

  /* A description order-CTA: inside .pt-pdp__desc AND either a vx…-cta button or a
     /cart/<digits>:<n> permalink (or any /cart … / /checkout link). The header cart icon
     (a.pt-iconbtn[href="/cart"]) is outside .pt-pdp__desc, so it is never matched. */
  function descCta(target){
    var a = target && target.closest ? target.closest('a') : null;
    if (!a || !a.closest('.pt-pdp__desc')) return null;
    if (/\bvx[\w-]*-cta\b/.test(a.className || '') || /\bfnx-(?:cta|scroll-to-shopify)\b/.test(a.className || '')) return a;
    var href = a.getAttribute('href') || '';
    var path = href.replace(/^https?:\/\/[^/]+/, '').split('?')[0];
    // /cart/<digits>:<n> permalink, or any /cart … / /checkout link.
    if (/^\/cart\/\d+:\d+$/.test(path) || /^\/cart(\/|$)/.test(path) || /^\/checkouts?(\/|$)/.test(path)) return a;
    return null;
  }

  /* The top buy section. Prefer the explicit #pt-buybox wrapper (price + qty + Vitals + ATC +
     Buy Now); fall back to known sub-elements so the shopper still lands on a working control. */
  function buyBox(){
    return document.getElementById('pt-buybox')
        || document.querySelector('.pt-pdp__info')
        || document.querySelector('.pt-pdp__add')
        || document.querySelector('.pt-pdp__price')
        || document.querySelector('form[data-pdp-form], form[action*="/cart/add"]')
        || document.querySelector('h1');
  }

  function pulse(box){
    // Brief visual cue on the buy box itself; scroll-margin-top (CSS) keeps it below the header.
    if (!box || !box.classList) return;
    box.classList.remove('pt-buybox--pulse');
    // force reflow so re-adding the class restarts the animation on rapid repeat clicks
    void box.offsetWidth;
    box.classList.add('pt-buybox--pulse');
    if (pulseTimer) clearTimeout(pulseTimer);
    pulseTimer = setTimeout(function(){ if (box.classList) box.classList.remove('pt-buybox--pulse'); }, 1300);
  }

  function scrollToBuyBox(){
    var box = buyBox();
    if (!box) return;
    /* 2026-06-24 FIX: smooth scrollIntoView is dead in the FB/IG mobile webview, turning every
       "Zamow" description-CTA click into a dead click. Instant deterministic jump + re-assert next
       frame to defeat the webview focus re-anchor, and pulse the real ATC so the shopper sees it. */
    var y = box.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 90;
    y = Math.max(0, y);
    window.scrollTo(0, y);
    requestAnimationFrame(function(){ window.scrollTo(0, y); });
    pulse(box);
    pulse(document.querySelector('[data-pdp-add]') || document.querySelector('button[name="add"]'));
  }

  function onMousedown(e){
    // Block the dead anchors from grabbing focus / jumping the page before our click runs.
    if (descCta(e.target)) e.preventDefault();
  }
  function onClick(e){
    var a = descCta(e.target);
    if (!a) return;
    e.preventDefault();          // no /cart navigation
    e.stopPropagation();         // do not reach the cart/checkout firewall or Releasit
    try { a.blur(); } catch(_){}
    scrollToBuyBox();
  }

  /* 2026-08-09 webview hardening: `new AbortController()` and the {signal} descriptor on
     addEventListener are absent/rejected on older FB/IG in-app webview engines. Previously
     either one throwing killed this whole IIFE BEFORE install() ran — no listeners at all,
     so every description CTA fell through to its raw href. Both are now optional: on failure
     we fall back to plain ES5 capture-boolean listeners and remove them by hand on teardown. */
  function install(){
    if (installed) return;
    installed = true;
    var opts;
    try {
      ac = new AbortController();
      opts = { capture: true, signal: ac.signal };
    } catch (e) {
      ac = null;
      opts = true;              // ES5 capture flag
    }
    try {
      document.addEventListener('mousedown', onMousedown, opts);
      document.addEventListener('click', onClick, opts);
    } catch (e) {
      // engine rejected the options object entirely — retry with the boolean form
      ac = null;
      try {
        document.addEventListener('mousedown', onMousedown, true);
        document.addEventListener('click', onClick, true);
      } catch (e2) {
        installed = false;      // genuinely cannot bind; leave state clean
      }
    }
  }
  function teardown(){
    if (!installed) return;
    installed = false;
    if (ac) {
      try { ac.abort(); } catch (e) {}
      ac = null;
    } else {
      try {
        document.removeEventListener('mousedown', onMousedown, true);
        document.removeEventListener('click', onClick, true);
      } catch (e) {}
    }
    if (pulseTimer) { clearTimeout(pulseTimer); pulseTimer = null; }
  }

  install();

  // Theme-editor / dynamic-section lifecycle: re-arm on load, release on unload.
  document.addEventListener('shopify:section:load', install);
  document.addEventListener('shopify:section:unload', teardown);
})();
